import React from 'react';

// eslint-disable-next-line react/prop-types
const ShopLocation = ({ map, shopName, line1, line2, phone, directions }) => {
  const locationImgStyle = map ? { backgroundImage: `url("${map}")` } : {};
  return (
    <div className="c-flagship-shop-location">
      <div className="c-flagship-shop-location__image" style={locationImgStyle} />
      <div className="u-pt-6 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex">
        <div className="u-ta-left">
          <div className="u-text-normal u-fw-bold u-mb-2">
            {shopName}
          </div>
          <div className="u-text-small u-co-grey u-mb-3">
            {line1},<br />
            {line2}<br />
            {phone}
          </div>
          <a className="u-text-normal u-co-grey" href={directions} target="_blank">
            Get directions
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShopLocation;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/FlagshipShopLocation.jsx